import { useEffect } from 'react';

const useWindowAnalytics = (analyticsFunc, dependencies = [], retryInMilliseconds = 1000, maxRetries = 3) => {
	useEffect(() => {
		let retryInterval;
		let retries = 0;

		const endTimer = () => {
			clearInterval(retryInterval);
			retryInterval = null;
		};

		if (window.analytics) {
			analyticsFunc();
		} else {
			retryInterval = setInterval(() => {
				if (window.analytics) {
					analyticsFunc();
					endTimer();
				} else if (retries == maxRetries) {
					endTimer();
				}
				retries++;
			}, retryInMilliseconds);
		}

		return () => {
			if (retryInterval) endTimer();
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [analyticsFunc, retryInMilliseconds, maxRetries, ...dependencies]);
};

export default useWindowAnalytics;
